<template>

  <CustomerFormArchEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-if="!mountAgain && pageEmbeddableLoaded && (accountModule === 'arch' || accountModule === 'estate' || accountModule === 'condo')"
      :enabled-submit="enabledSubmit" />

  <CustomerFormProductionEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-else-if="!mountAgain && pageEmbeddableLoaded && accountModule === 'production'"
      :enabled-submit="enabledSubmit" />

  <CustomerFormERPEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-else-if="!mountAgain && pageEmbeddableLoaded && accountModule === 'erp'"
      :enabled-submit="enabledSubmit"
  />

</template>
<script>
import customerFormEmbeddableMixin from "@/mixins/embeddable/customer/customerFormEmbeddableMixin";
import ui from "@/assets/scripts/ui";

export default {
  name: 'CustomerForm',
  mixins: [customerFormEmbeddableMixin],
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()
    },
    async mountedContinued() {

      //Necessário realizar a montagem básica antes para saber qual componente renderizar
      await this.getAssemble('customer', 'form')

      this.pageEmbeddableLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onBeforeSubmit() {

      //Libera a continuidade sem nenhuma condição especial
      this.enabledSubmit = true
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
